//* Libraries imports
import { Suspense } from "react";

//* Components imports
import { Content } from "./_componentes/index";
import { WithPermissionCheck } from "../../../components/common/WithPermissionCheck";

export default function ProcessEditalView() {
  return (
    <WithPermissionCheck>
      <div className="row">
        <Suspense>
          <Content />
        </Suspense>
      </div>
    </WithPermissionCheck>
  );
}
